import styled from 'styled-components';
import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';
import { Icon } from '@web-chat-core/ui-kit';

export const MeetButton = styled.button`
    display: flex;
    align-items: center;
    min-height: 40px;
    border-radius: 44px;
    border: none;
    background: ${(props) => props.theme.root.colors.basicColors['10%']};
    padding: 4px 16px;
    cursor: pointer;
    color: ${(props) => props.theme.root.colors.basicColors['90%']};
    font-weight: normal;
    font-size: 14px;
    white-space: nowrap;

    &:active {
        border: none;
    }

    &:hover {
        background: ${(props) => props.theme.root.colors.basicColors['15%']};
    }

    &:disabled {
        opacity: 0.5;
        cursor: default;
    }

    .icon {
        display: inline-block;
        margin-right: 8px;
    }
`;

export const MenuTriggerIcon = styled(Icon)``;

export const MenuTrigger = styled(MeetButton)<{
    $on: boolean;
}>`
    ${(props) => (props.$on ? null : `background: ${props.theme.root.colors.basicColors.white['80%']}`)};

    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    padding-left: 12px;
    padding-right: 11px;
    margin-left: 0;

    & ${MenuTriggerIcon} {
        transition: transform 0.15s ease;
    }

    &[data-state='open'] ${MenuTriggerIcon} {
        transform: rotate(180deg);
    }

    &:hover {
        ${(props) => (props.$on ? null : `background: ${props.theme.root.colors.basicColors.white['100%']}`)};

        ${MenuTriggerIcon} {
            fill: ${(props) =>
                props.$on
                    ? props.theme.root.colors.basicColors.white['100%']
                    : props.theme.root.colors.basicColors.black['95%']};
        }
    }
`;

export const Separator = styled(DropdownMenuPrimitive.Separator)`
    height: 1px;
    width: 100%;
    background: ${(props) => props.theme.root.colors.basicColors['10%']};
    margin-top: 6px;
    margin-bottom: 6px;
`;
